export default "__VITE_ASSET__CYRTz4TM__"